module.exports = __webpack_public_path__ + "img/yx2.63cea8c3.jpg";